 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLABTNYUP_PRESS from '@/components/xhtml/abtnyup_press'
 import XHTMLCH0001_HALFTITLE from '@/components/xhtml/ch00-01_halftitle'
 import XHTMLCH0002_TITLE from '@/components/xhtml/ch00-02_title'
 import XHTMLCH0003_COPY from '@/components/xhtml/ch00-03_copy'
 import XHTMLCH0004_CONTENT from '@/components/xhtml/ch00-04_content'
 import XHTMLCH0005_ACKNOWLEDGMENTS from '@/components/xhtml/ch00-05_Acknowledgments'
 import XHTMLCH0006_INTRODUCTION from '@/components/xhtml/ch00-06_Introduction'
 import XHTMLCH0007_HALFTITLE from '@/components/xhtml/ch00-07_halftitle'
 import XHTMLCH01_PARTONE from '@/components/xhtml/ch01_partone'
 import XHTMLCH01 from '@/components/xhtml/ch01'
 import XHTMLCH02 from '@/components/xhtml/ch02'
 import XHTMLCH03_PARTTWO from '@/components/xhtml/ch03_parttwo'
 import XHTMLCH03 from '@/components/xhtml/ch03'
 import XHTMLCH04 from '@/components/xhtml/ch04'
 import XHTMLCH05 from '@/components/xhtml/ch05'
 import XHTMLCH06_PARTTHREE from '@/components/xhtml/ch06_partthree'
 import XHTMLCH06 from '@/components/xhtml/ch06'
 import XHTMLCH07 from '@/components/xhtml/ch07'
 import XHTMLCH08_PARTFOUR from '@/components/xhtml/ch08_partfour'
 import XHTMLCH08 from '@/components/xhtml/ch08'
 import XHTMLCH09 from '@/components/xhtml/ch09'
 import XHTMLCH10 from '@/components/xhtml/ch10'
 import XHTMLCH11_NOTES from '@/components/xhtml/ch11_notes'
 import XHTMLCH12_INDEX from '@/components/xhtml/ch12_index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/ch00-04_content",
 			"name" : "xhtml/ch00-04_content",
 			"component" : XHTMLCH0004_CONTENT
 		},
 		{
 			"path" : "/xhtml/ch00-05_Acknowledgments",
 			"name" : "xhtml/ch00-05_Acknowledgments",
 			"component" : XHTMLCH0005_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/xhtml/ch00-06_Introduction",
 			"name" : "xhtml/ch00-06_Introduction",
 			"component" : XHTMLCH0006_INTRODUCTION
 		},
 		{
 			"path" : "/xhtml/ch00-07_halftitle",
 			"name" : "xhtml/ch00-07_halftitle",
 			"component" : XHTMLCH0007_HALFTITLE
 		},
 		{
 			"path" : "/xhtml/ch01_partone",
 			"name" : "xhtml/ch01_partone",
 			"component" : XHTMLCH01_PARTONE
 		},
 		{
 			"path" : "/xhtml/ch01",
 			"name" : "xhtml/ch01",
 			"component" : XHTMLCH01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js